import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function CurrentTemperature(props) {
  const className = props.balance
    ? `${style.currentTemparature}`
    : `${style.currentTemparature_inBalance}`;

  return <h3 className={className}>{props.currentTemp}°C</h3>;
}
CurrentTemperature.propTypes = {
  /**
   * State to store the currentTemp value
   */
  currentTemp: PropTypes.number,
  /**
   * It denotes the current temperature and the setTemperature is equal or not
   */
  balance: PropTypes.bool,
};
